import { createContext, useContext, useMemo, useState } from 'react';

/**
 * WorkoutControlsContext — deja que una pantalla (la sesión de entrenamiento)
 * tome el control del disco flotante (QuickActionsFab) mientras está abierta.
 *
 * control = { label, mode: 'play'|'pause'|'stop'|'skip'|'log'|'done', active, onPress }
 * Si control es null, el disco abre las acciones rápidas de siempre.
 */
const Ctx = createContext({ control: null, setControl: () => {} });

export const WorkoutControlsProvider = ({ children }) => {
  const [control, setControl] = useState(null);
  const value = useMemo(() => ({ control, setControl }), [control]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useWorkoutControls = () => useContext(Ctx);
